<template>
  <div class="progress">
    <div class="bar">
      <div :class="{ inProgress: progress }" :style="progressWidth"></div>
    </div>
    <div class="info">
      <div>
        <div class="rev" v-if="revenue > 0">
          <img src="@/assets/img/coin.svg" alt="Coins" v-if="!med" />
          <img src="@/assets/img/pop-healed.svg" alt="Coins" v-else />
          <span class="smallNumber2">{{ fRevenue }}</span>
        </div>
      </div>
      <span
        class="smallNumber1 timeLeft"
        :style="'width:' + timeLeftWidth + 'px'"
        >{{ timeLeft }}s</span
      >
    </div>
  </div>
</template>

<script>
import nFormatter from "@/mixins/nFormatter.js";

export default {
  name: "Progress Bar",
  mixins: [nFormatter],
  emits: ["finish"],
  props: {
    time: Number,
    revenue: Number,
    progress: Boolean,
    med: Boolean,
  },
  data() {
    return {
      timePassed: 0,
      interVal: 0,
      duration: 0,
      reseted: false,
      timePassChunk: 0.1, // time progress length
      timeOut: {},
    };
  },

  computed: {
    timeMulti: function() {
      return this.$store.state.timeMulti;
    },

    gamePause: function() {
      return this.$store.state.gamePause;
    },

    progressWidth: function() {
      let percent = (this.timePassed / this.time) * 100;
      return { width: +percent + "%" };
    },

    timeLeftWidth: function() {
      return this.time.toString().length * 20;
    },
    calcRevenue: function() {
      return this.med ? this.revenue / 1000 : this.revenue;
    },
    fRevenue: function() {
      // return this.calcRevenue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return this.nFormatter(this.calcRevenue, 2);
    },

    tabSwitch: function() {
      return this.$store.state.tabSwitch;
    },

    timeLeft: function() {
      let newTime = (this.time - this.timePassed).toFixed(1);
      return this.progress ? Number(newTime) : this.time;
    },

    fTimePassed: function() {
      return this.timePassed.toFixed(1);
    },

    lockdown: function() {
      return this.$store.state.lockdown;
    },
  },
  mounted: function() {
    if (this.progress) {
      this.duration = this.time;
      this.startTimeCount();
      this.finishProgress(this.time);
    }
  },
  watch: {
    // Final Action
    progress: function(bool) {
      if (bool) {
        this.duration = this.time;
        this.startTimeCount();
        this.finishProgress(this.time);
      }
    },

    tabSwitch: function() {
      if (this.progress) {
        this.duration = this.timeLeft;
      }
    },

    lockdown: function(bool) {
      // lockdown
      if (bool && !this.med && this.progress) {
        clearInterval(this.interVal);
        clearTimeout(this.timeOut);
        this.timePassed = 0;
      } else if (!bool && !this.med) {
        this.$emit("finish");
      }
    },

    gamePause: function(bool) {
      if (!this.lockdown) {
        // if paused
        if (bool) {
          clearInterval(this.interVal);
          clearTimeout(this.timeOut);
        } else {
          if (this.progress) {
            this.timePassed = 0;
            this.duration = this.time;
            this.startTimeCount();
            this.finishProgress(this.time);
          }
        }
      }
    },
  },

  methods: {
    startTimeCount: function() {
      this.interVal = setInterval(() => {
        this.timePassed = this.timePassed + this.timePassChunk;
      }, 100);
    },

    finishProgress: function(time) {
      this.timeOut = setTimeout(() => {
        this.$emit("finish");

        // wtf bug
        if (document.visibilityState === "visible") {
          if (this.med) {
            this.$store.commit("addHealed", this.calcRevenue);
            this.trackVal("Earn Medicine", "EARN", this.calcRevenue);
          } else if (!this.lockdown) {
            this.$store.commit("addMoney", this.revenue);
            this.trackVal("Earn Production", "EARN", this.revenue);
          }
        }

        this.timePassed = 0;
        this.duration = this.time;
        clearInterval(this.interVal);
      }, time * 1000);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/scss/vars.scss";
.progress {
  display: flex;
  width: 100%;
  align-items: center;
  .bar {
    width: 100%;
    height: 6px;
    border-radius: 6px;
    background: $gray300;
    margin-right: 12px;
    overflow: hidden;

    div {
      height: 100%;
      background: $blue;
      width: 0;
    }

    .inProgress {
      transition: 0.1s linear;
    }
  }

  .frozen div {
    background: $gray800;
  }

  .info {
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    .timeLeft {
      min-width: 30px;
      text-align: right;
    }

    .rev {
      display: flex;
      img {
        margin-right: 4px;
        width: 12px;
      }
    }
  }
}

@keyframes progress {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}
</style>
